import apiClient from './apiClient';

export interface FAQ {
  _id: string;
  question: string;
  answer: string;
  category?: string;
  order: number;
  isActive: boolean;
  createdBy?: {
    _id: string;
    name?: string;
    username?: string;
  };
  updatedBy?: {
    _id: string;
    name?: string;
    username?: string;
  };
  createdAt: string;
  updatedAt: string;
}

class FAQService {
  async getFAQs(category?: string, isActive?: boolean | 'all') {
    const params: any = {};
    if (category) params.category = category;
    if (isActive !== undefined) params.isActive = isActive.toString();
    
    const response = await apiClient.get('/faqs', { params });
    return response.data;
  }

  async getFAQById(id: string) {
    const response = await apiClient.get(`/faqs/${id}`);
    return response.data;
  }

  async createFAQ(data: Partial<FAQ>) {
    const response = await apiClient.post('/faqs', data);
    return response.data;
  }

  async updateFAQ(id: string, data: Partial<FAQ>) {
    const response = await apiClient.put(`/faqs/${id}`, data);
    return response.data;
  }

  async deleteFAQ(id: string) {
    const response = await apiClient.delete(`/faqs/${id}`);
    return response.data;
  }

  async reorderFAQs(faqOrders: { id: string; order: number }[]) {
    const response = await apiClient.post('/faqs/reorder', { faqOrders });
    return response.data;
  }

  async toggleFAQStatus(id: string) {
    const response = await apiClient.patch(`/faqs/${id}/toggle-status`);
    return response.data;
  }
}

export const faqService = new FAQService();
export default faqService;

